import React from "react";
import {useTranslation} from "react-i18next";

interface BreadcrumbsProps {
  sectionLabel: string;
  resourceLabel?: string;
  onHome: () => void;
  actions?: React.ReactNode;
}

export default function Breadcrumbs({sectionLabel, resourceLabel, onHome, actions}: BreadcrumbsProps) {
  const {t} = useTranslation();
  const visibleResourceLabel = resourceLabel?.trim().toLocaleLowerCase()
    === sectionLabel.trim().toLocaleLowerCase() ? undefined : resourceLabel;
  if (!resourceLabel && sectionLabel === t("overview")) {
    return <nav className="breadcrumbs" aria-label={t("breadcrumbs.label")}><strong aria-current="page">{t("overview")}</strong></nav>;
  }
  return <div className="breadcrumbs-row">
    <nav className="breadcrumbs" aria-label={t("breadcrumbs.label")}>
      <button type="button" title={t("overview")} onClick={onHome}>{t("overview")}</button>
      <span aria-hidden="true">/</span>
      <span>{sectionLabel}</span>
      {visibleResourceLabel && <><span aria-hidden="true">/</span><strong aria-current="page">{visibleResourceLabel}</strong></>}
    </nav>
    {actions && <div className="breadcrumbs-actions">{actions}</div>}
  </div>;
}
